import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


var vUI_Fund_Type_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_FUNDTYPE_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Fund Type WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    FUNDTYPE_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Fund Type Id', columnResourceName: 'colFundTypeId', alignment: HorizAlignment.Right}, domainOptions: { maxLength: 50}},
    FUNDTYPE_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    WB_FK_ROW_ID:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'FK Row ID', columnResourceName: 'colFKRowID', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 100}},
    SOURCE_ID:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source ID', columnResourceName: 'colSourceID', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}}
}

var FundTypeSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_FUNDTYPE_ID',
        id_ui: 'FUNDTYPE_ID',
        name:  'FUNDTYPE_NAME'},


    searchProviderFields: vUI_Fund_Type_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Fund_Type_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var FundTypeSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "FundTypeSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'FUNDTYPE_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'FUNDTYPE_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'FUNDTYPE_ID','FUNDTYPE_NAME','WB_FK_ROW_ID','SOURCE_ID'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: FundTypeSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var FundTypeSearch: ISearch = {
    searchName: "Find Fund Type",
    renderOptions: { ui5ResourceId: "FundTypeSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [FundTypeSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("FundTypeBO", "FundType", FundTypeSearch, "Fund Type Search")

export {FundTypeSearch}